export const BLOCK_TYPE_GUIDEBOOK_LIST_ALL = 'guidebook-list-all';
